export default __webpack_public_path__ + "static/media/coinbaseWalletIcon.a3a7d7fd.svg";